import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'
import jwt from 'jwt-decode'
export const customer_register = createAsyncThunk(
    'auth/customer_register',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/customer/customer-register', info)
            localStorage.setItem('riderToken', data.token)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const rider_register = createAsyncThunk(
    'auth/rider_register',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        console.log(info)
        try {
            const { data } = await api.post('/rider/rider-register', info)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const rider_login = createAsyncThunk(
    'auth/rider_login',
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post("/rider/rider-login", info, {
              withCredentials: true,
            });
            localStorage.setItem("riderToken", data.token);
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


const decodeToken = (token) => {
    if (token) {
        const userInfo = jwt(token)
        return userInfo
    } else {
        return ''
    }
}

export const authReducer = createSlice({
    name: 'auth',
    initialState: {
        loader: false,
        userInfo: decodeToken(localStorage.getItem('riderToken')),
        errorMessage: '',
        successMessage: ''
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = ''
            state.successMessage = ''
        },
        user_reset: (state, _) => {
            state.userInfo = ""
        }
    },
    extraReducers: {
        [rider_register.pending]: (state, _) => {
            state.loader = true
        },
        [rider_register.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
            state.loader = false
        },
        [rider_register.fulfilled]: (state, { payload }) => {
            state.successMessage = payload.message
            state.loader = false
        },
        [rider_login.pending]: (state, _) => {
            state.loader = true
        },
        [rider_login.rejected]: (state, { payload }) => {
            state.errorMessage = payload.message
            state.loader = false
        },
        [rider_login.fulfilled]: (state, { payload }) => {
            const userInfo = decodeToken(payload.token)
            state.successMessage = payload.message
            state.loader = false
            state.userInfo = userInfo
        },
    }
})

export const { messageClear, user_reset } = authReducer.actions
export default authReducer.reducer